import { useMutation, useQueryClient } from "@tanstack/react-query";

import { USER_INFO_QUERY_KEY } from "Auth/Api/Queries/useUserInfoQuery";
import { JWT_KEY } from "Auth/Models/AuthConstants";
import {
	type FetchResponseOfError,
	type IdentityProvider,
	postAuthSso,
} from "Infrastructure/Api/Api";
import { ApiCallError } from "Infrastructure/Api/ApiUtils";

interface SsoMutationParams {
	token: string;
	identityProvider: IdentityProvider;
	onSuccessCallback?: () => void;
}

export function useSsoMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: SsoMutationParams) =>
			postAuthSso({
				token: params.token,
				identityProvider: params.identityProvider,
			}),
		onSuccess: (data, variables) => {
			if (data.status === 404 || data.status === 401) {
				throw new ApiCallError(data as unknown as FetchResponseOfError);
			}

			if (data.status === 200) {
				localStorage.setItem(JWT_KEY, `Bearer ${data.data.userInfo.token}`);

				// Call callback BEFORE invalidateQueries to ensure navigation happens
				variables.onSuccessCallback?.();
			}

			queryClient.invalidateQueries({ queryKey: [USER_INFO_QUERY_KEY] });
		},
	});
}
